<template>
  <footer class="lf-footer">
    <div class="container">
      <div class="lf-footer__grid">

        <!-- Brand + descripción -->
        <div class="lf-footer__brand">
          <router-link to="/" class="lf-footer__logo">
            <img src="/images/logo-lafuerza.png" alt="LaFuerza IT Chile" width="32" height="32">
            <span>LaFuerza<span class="lf-accent">.</span>IT</span>
          </router-link>
          <p>
            Partner tecnológico chileno. Desarrollo de software a medida,
            SaaS e infraestructura cloud para empresas que crecen.
          </p>

          <!-- Redes sociales -->
          <div class="lf-footer__social">
            <a
              href="https://www.instagram.com/lafuerzait/"
              target="_blank"
              rel="me noopener noreferrer"
              aria-label="Instagram de LaFuerza IT"
              class="lf-footer__social-link"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
              </svg>
            </a>
          </div>
        </div>

        <!-- Servicios -->
        <div>
          <h4 class="lf-footer__title">Servicios</h4>
          <ul class="lf-footer__list">
            <li><a href="/#servicios">Desarrollo web</a></li>
            <li><a href="/#servicios">Aplicaciones SaaS</a></li>
            <li><a href="/#servicios">Migración de datos</a></li>
            <li><a href="/#servicios">Infraestructura cloud</a></li>
            <li><a href="/#servicios">Consultoría IT</a></li>
          </ul>
        </div>

        <!-- Empresa -->
        <div>
          <h4 class="lf-footer__title">Empresa</h4>
          <ul class="lf-footer__list">
            <li><a href="/#nosotros">Nosotros</a></li>
            <li><a href="/#contacto">Contacto</a></li>
            <li><router-link to="/politica-privacidad">Privacidad</router-link></li>
            <li><router-link to="/terminos-condiciones">Términos</router-link></li>
            <li><router-link to="/politica-cookies">Cookies</router-link></li>
          </ul>
        </div>

        <!-- Contacto -->
        <div>
          <h4 class="lf-footer__title">Contacto</h4>
          <ul class="lf-footer__list">
            <li>
              <a
                href="https://www.instagram.com/lafuerzait/"
                target="_blank"
                rel="me noopener noreferrer"
                class="lf-footer__contact"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
                @lafuerzait
              </a>
            </li>
            <li>
              <a href="mailto:contacto@lafuerzait.cl" class="lf-footer__contact">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                contacto@lafuerzait.cl
              </a>
            </li>
            <li>
              <a href="tel:+56950111647" class="lf-footer__contact">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z"/></svg>
                +56 9 5011 1647
              </a>
            </li>
            <li class="lf-footer__contact lf-footer__contact--dim">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              Lun–Vie · 9:00–18:00
            </li>
          </ul>
        </div>

      </div>

      <div class="lf-footer__bottom">
        <p class="lf-footer__made">
          Hecho en Chile <span aria-hidden="true">🇨🇱</span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    year() { return new Date().getFullYear() }
  }
}
</script>

<style scoped>
.lf-footer {
  margin-top: 80px;
  padding: 80px 0 32px;
  background: var(--lf-bg-2);
  border-top: 1px solid var(--lf-border);
}

.lf-footer__grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr;
  gap: 48px;
  padding-bottom: 48px;
  border-bottom: 1px solid var(--lf-border);
}

/* Brand */
.lf-footer__brand .lf-footer__logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: var(--lf-font-display);
  font-weight: 600;
  font-size: 1.1rem;
  color: var(--lf-text);
  margin-bottom: 16px;
}
.lf-footer__brand img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}
.lf-footer__brand p {
  color: var(--lf-text-mute);
  font-size: 14px;
  line-height: 1.7;
  max-width: 360px;
  margin: 0 0 20px;
}

/* Redes sociales */
.lf-footer__social {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}
.lf-footer__social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid var(--lf-border);
  background: rgba(255, 255, 255, 0.02);
  color: var(--lf-text-mute);
  transition: all 0.25s ease;
}
.lf-footer__social-link:hover {
  color: var(--lf-accent);
  border-color: rgba(0, 229, 255, 0.4);
  background: rgba(0, 229, 255, 0.06);
  transform: translateY(-2px);
}
.lf-footer__social-link:focus-visible {
  outline: 2px solid var(--lf-accent);
  outline-offset: 2px;
}

/* Columnas */
.lf-footer__title {
  font-family: var(--lf-font-display);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--lf-text);
  margin: 0 0 20px;
}

.lf-footer__list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.lf-footer__list a,
.lf-footer__list li {
  color: var(--lf-text-mute);
  font-size: 14px;
  transition: color 0.2s;
}
.lf-footer__list a:hover { color: var(--lf-accent); }

.lf-footer__contact {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.lf-footer__contact svg { flex-shrink: 0; opacity: 0.7; }
.lf-footer__contact--dim { color: var(--lf-text-dim); }

/* Bottom */
.lf-footer__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  padding-top: 32px;
  font-size: 13px;
  color: var(--lf-text-dim);
}
.lf-footer__bottom p { margin: 0; }
.lf-footer__made { font-size: 13px; }

/* Responsive */
@media (max-width: 991px) {
  .lf-footer__grid {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
}
@media (max-width: 576px) {
  .lf-footer { padding: 60px 0 24px; }
  .lf-footer__grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  .lf-footer__bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>